const defaultState = {
  report: {},
  error: null,
  fetching: false,
  fetched: false
};

const getPhysicalDamageReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'PHYSICAL_DAMAGE_CLEAR': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: null
      };
    }
    case 'PHYSICAL_DAMAGE_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true, report: {}
      };
    }
    case 'PHYSICAL_DAMAGE_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: action.payload.data
      };
    }
    case 'PHYSICAL_DAMAGE_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        report: {},
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getPhysicalDamageReducer;


// WEBPACK FOOTER //
// ./src/reducers/getPhysicalDamage.js